import React from 'react';
import { Link } from 'react-router-dom';
import ringsImg from '../assets/categories/rings.jpg';
import braceletsImg from '../assets/categories/bracelets.jpg';
import necklacesImg from '../assets/categories/necklaces.jpg';
import earringsImg from '../assets/categories/earrings.jpg';

const categories = [
  { title: 'NECKLACES', image: necklacesImg, link: '/shop?category=necklace' },
  { title: 'BRACELETS', image: braceletsImg, link: '/shop?category=bracelet' },
  { title: 'RINGS', image: ringsImg, link: '/shop?category=ring' },
  { title: 'EARRINGS', image: earringsImg, link: '/shop?category=earring' },
    ];
  

const CategoryGrid = () => {
  return (
    <section className="grid grid-cols-2 md:grid-cols-2 gap-2 md:gap-8 px-2 md:px-8 py-10 font-montserrat">
      {categories.map((cat, index) => (
        <Link
          key={index}
          to={cat.link}
          className="group relative overflow-hidden flex items-end justify-start h-[250px] sm:h-[300px] md:h-[400px] lg:h-[500px] xl:h-[600px]
 bg-cover bg-center"
          style={{ backgroundImage: `url(${cat.image})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-10 group-hover:bg-opacity-30 sm:transition-opacity duration-500 ease-in-out" />

          <div className="relative z-10 p-6 text-white">
            <h2 className="uppercase tracking-[2.6px] font-medium text-[12px] md:text-2xl">
              {cat.title}
            </h2>
            <button className="md:mt-3 border border-white text-[#3b3d6e] bg-white py-2 px-2 md:px-5  text-[8px] md:text-xs uppercase tracking-widest transition-all duration-500 ease-in-out hover:bg-transparent hover:text-white">
  DISCOVER NOW
</button>

          </div>

          <img
            src={cat.image}
            alt={cat.title}
            className="absolute inset-0 w-full h-full object-cover scale-100 group-hover:scale-110 transition-transform duration-[3000ms] ease-in-out
"
          />
        </Link>
      ))}
    </section>
  );
};

export default CategoryGrid;
